module.exports = __webpack_public_path__ + "static/media/StarWars.fa11d3c4.jpg";